import { Container, Grid, useMediaQuery } from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import React from "react";
import scan2pay_img from "../../../../assets/images/scan2pay_content.png";
import ContentList from "../../components/contentList";
import IconHeader from "../../components/iconHeader";
import TextList from "../../components/TextList";

const useStyles = makeStyles((theme) => ({
  img: {
    width: "100%",
  },
}));


export default function Scan2Header() {
  const classes = useStyles();
  const theme = useTheme();
  const sm = useMediaQuery(theme.breakpoints.up("sm"));
  const xs = useMediaQuery(theme.breakpoints.down("xs"));

  return (
    <Container>
      <Grid container direction="row" justifyContent="center" alignItems="center">
        {xs && (
          <Grid item xs={6}>
            <IconHeader
              title="Scan... Pay... Go!"             
              titleColor ="#C60B17"
              titleLg="h2"
              titleXs="h4"
              icon={false}

            />
          </Grid>
        )}
        {xs && (
          <Grid item xs={6}>
            <img src={scan2pay_img} alt="topup" className={classes.img}/>
          </Grid>
        )}
        <Grid item container xs={12} sm={7}>
          {sm && (
            <Grid item>
              <IconHeader
                title="Scan... Pay... Go!"
                iconColor="#cb010d"
                titleColor ="#C60B17"
                titleLg="h2" 
                icon={false}
              />
            </Grid>
          )}
          <Grid item container>
            <TextList
              items={[
                <span>Your business is taking off but your payment options are not… <span style={{color:"#cb010d",fontWeight:"bold"}}>YOOZ Scan2Pay</span> is the answer! </span>,
                
                
              ]}
              indentation="3%"
            />
            <ContentList
                items={[
                    <span>
                                    Introducing the ﬁrst, secure, contactless payment
                                    solution that lets your customers pay for all of your 
                                    goods and services by scanning your unique 
                                    <b> YOOZ QR Code</b> or clicking your secure <b>YOOZ URL Link</b> so you can get paid without the 
                                    hassle of terminals, e-transfers, hidden fees and payment delays. 
                                </span>
                ]}
            
            />
          </Grid>
        </Grid>
        {sm && (
          <Grid item xs={6} sm={5}>
            <img src={scan2pay_img} alt="topup" className={classes.img}/>
          </Grid>
        )}
      </Grid>
    </Container>
  );
}
